module.exports = __webpack_public_path__ + "media/images/favicon/francsenergie.ncode.ch-ac94b9302f514a5b674e8055f78f7e4c.webmanifest";